import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ShiftType } from '../class-models/common';
import { OperatorDetail } from '../class-models/operator';



@Injectable({
  providedIn: 'root'
})
export class CommonService {
  baseUrl?: string = '';
  GIS_API_KEY?: string = '';
  constructor(private http: HttpClient) {
    this.baseUrl = environment.BASE_URL;
    this.GIS_API_KEY = environment.GIS_API_KEY;
  }

  GetCurrentShiftDetails(unitId: number): Observable<ShiftType[]> {
    // return this.http.get<ShiftType[]>(this.baseUrl + "Common/GetCurrentShiftFromCurrentTime");
    return this.http.get<ShiftType[]>(this.baseUrl + "Common/GetCurrentShift?unitId=" + unitId);
  }

  GetCurrentShiftDetailsWithDateShift(unitId: number, startDate: any, shiftName: any): Observable<ShiftType[]> {
    // return this.http.get<ShiftType[]>(this.baseUrl + "Common/GetCurrentShiftFromCurrentTime");
    return this.http.get<ShiftType[]>(this.baseUrl + "Common/GetCurrentShift?unitId=" + unitId + "&date=" + startDate + "&shift=" + shiftName);
  }

  GetAllShiftDetails(): Observable<ShiftType[]> {
    return this.http.get<ShiftType[]>(this.baseUrl + "Common/GetShiftTypes");
  }

  GetOperatorDetailsByType(type: string): Observable<OperatorDetail[]> {
    return this.http.get<OperatorDetail[]>(this.baseUrl + "Common/GetOperatorSkillGradeByAssetType?assetTypeId=" + type);
  }

  GetCrusherMasterDetails(): Observable<any> {
    return this.http.get<any>(this.baseUrl + "Common/GetCrusherTypes");
  }

  GetAllEquipmentStatusDetailsCount() {
    return this.http.get<any>(this.baseUrl + "EquipmentMaintenanceNew/GetAllEquipmentStatusDetailsByType");
  }
  AutoUpdateCrusherShiftTargetAllocationForOptimizationNew() {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'x-api-key': this.GIS_API_KEY
        }
      )
    };
    return this.http.get<any>(this.baseUrl + "CrusherPlanAllocation/AutoUpdateCrusherShiftTargetAllocationForOptimizationNew", httpOptions);
  }
  AutoUpdateCrusherShiftTargetAllocation() {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'x-api-key': this.GIS_API_KEY
        }
      )
    };
    return this.http.get<any>(this.baseUrl + "CrusherPlanAllocation/AutoUpdateCrusherShiftTargetAllocationNew", httpOptions);
  }

  getQualityRadicalList(): Observable<any[]> {
    return this.http.get<any>(this.baseUrl + "QualityRadical/GetQualityRadicalList");
  }

}
